import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  font-size: 15px;
  border-bottom: solid 1px #8e8e8e;
  &.loading {
    opacity: 1;
    position: relative;
  }
  &.loading:after {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    /* z-index: 999; */
    border-radius: 4px;
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.75) url(/images/loader.svg) no-repeat 50%;
  }
`;

export const Label = styled.label`
  margin: 0;
  padding: 0;
  width: 200px;
  flex-shrink: 0;
  margin: 0 15px 0 0;
  padding-right: 3px;
  height: 40px;
  line-height: 40px;
`;

export const Value = styled.div`
  width: 100%;
  button {
    width: 100%;
    /* font-size: 14px; */
    letter-spacing: -0.02em;
    padding: 0 10px;
    margin: 0 0 15px;
  }
`;

export const Cnt = styled.div`
  height: 40px;
  line-height: 40px;
`;
